import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import { formatBRL } from '../utils/currency';
import '../styles/Cart.css';

type AddedDetail = {
  skuId: string;
  qty: number;
  productName: string;
  variantName?: string;
  unitPriceCents: number;
  image?: string;
  isKit?: boolean;
  includes?: string[];
};

const CartToast: React.FC = () => {
  const { items, setQty, openCart } = useCart();
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState<AddedDetail | null>(null);
  const [timer, setTimer] = useState<number | undefined>(undefined);

  useEffect(() => {
    const handler = (e: Event) => {
      const { detail } = e as CustomEvent<AddedDetail>;
      setDetail(detail);
      setVisible(true);
      if (timer) window.clearTimeout(timer);
      const t = window.setTimeout(() => setVisible(false), 5000);
      setTimer(t);
    };
    window.addEventListener('cart:add' as any, handler as any);
    return () => {
      window.removeEventListener('cart:add' as any, handler as any);
      if (timer) window.clearTimeout(timer);
    };
  }, [timer]);

  const undo = () => {
    if (!detail) return;
    const current = items.find((i) => i.skuId === detail.skuId)?.qty || 0;
    const next = Math.max(0, current - (detail.qty || 1));
    setQty(detail.skuId, next);
    setVisible(false);
  };

  if (!visible || !detail) return null;

  const label = [detail.productName, detail.variantName].filter(Boolean).join(' — ');

  return (
    <div className={`cart-toast ${visible ? 'show' : ''}`} role="status" aria-live="polite">
      <div className="cart-toast-content">
        {detail.image && <img src={detail.image} alt="" loading="lazy" decoding="async" />}
        <div className="cart-toast-text">
          <strong>Adicionado ao carrinho</strong>
          <span>
            {label} ×{detail.qty} • {formatBRL(detail.unitPriceCents)}
          </span>
          {detail.isKit && detail.includes?.length ? (
            <ul>
              {detail.includes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
      <div className="cart-toast-actions">
        <button className="btn-primary" onClick={openCart}>Ver carrinho</button>
        <button className="btn-secondary" onClick={undo}>Desfazer</button>
      </div>
    </div>
  );
};

export default CartToast;
